import React from 'react';

/**
 * If passed a single Fragment, returns its children; otherwise, returns the
 * argument received.
 * @param node The React node to potentially extract children from
 */
export function getFlattenedChildren(node: React.ReactNode) {
  if (React.isValidElement<{ children?: React.ReactNode }>(node) && node.type === React.Fragment) {
    return node.props.children;
  }

  return node;
}

/**
 * Like React.Children.map, but treats a top-level Fragment as an array and maps
 * over its children instead of treating the Fragment itself as a single child.
 * This is not recursive, so nested Fragments and arrays (even an array
 * containing a Fragment) are left as-is.
 * @param children Children to be flattened and mapped
 * @param fn Mapping function
 */
export function childrenFlatMap<T>(
  children: React.ReactNode,
  fn: (child: React.ReactNode, index: number) => T,
) {
  return React.Children.map<T, React.ReactNode>(getFlattenedChildren(children), fn);
}
